<div class="image">
  <picture>
    <source media="(max-width: 575.9px)" [srcset]="card?.card?.imageBlock?.mobile?.file" />
    <source media="(min-width: 992px)" [srcset]="card?.card?.imageBlock?.desktop?.file" />
    <source media="(min-width: 576px)" [srcset]="card?.card?.imageBlock?.tablet?.file" />
    <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
    <img
      height="575"
      width="575"
      [loaderParams]="{ builder: true }"
      [ngSrc]="card?.card?.imageBlock?.desktop?.file || ''"
      [alt]="card?.card?.imageBlock?.altText"
      [style.object-fit]="currentImageFit"
    />
  </picture>
</div>
<div class="overlay">
  @if (!card?.card?.cta?.cta?.hide) {
    <a
      [tabIndex]="isVisible ? 0 : -1"
      class="link"
      [ngClass]="card?.card?.cta?.cta?.style ? ('link-' + card?.card?.cta?.cta?.style | lowercase) : 'link-white'"
      [href]="card?.card?.cta?.cta?.link"
      [title]="card?.card?.cta?.cta?.altText"
      [attr.target]="card?.card?.cta?.cta?.newTab ? '_blank' : '_self'"
      >{{ card?.card?.cta?.cta?.text }}</a
    >
  }
  @if (!card?.card?.cta?.actionLink?.hide) {
    <a
      [tabIndex]="isVisible ? 0 : -1"
      class="button"
      role="button"
      [ngClass]="
        card?.card?.cta?.actionLink?.style ? ('button-' + card?.card?.cta?.actionLink?.style | lowercase) : 'button-white'
      "
      [href]="card?.card?.cta?.actionLink?.link"
      [title]="card?.card?.cta?.actionLink?.altText"
      [attr.target]="card?.card?.cta?.actionLink?.newTab ? '_blank' : '_self'"
    >
      {{ card?.card?.cta?.actionLink?.text }}
    </a>
  }
</div>
